import type { AppDispatch } from '@/app/store/store';
import { PdpAdapter } from '../infra/adapters/pdp.adapter';
import { CustomizationAdapter } from '@/features/customization/infra/adapters/customization.adapter';
import { PdpDeliveryAdapter } from '../infra/adapters/pdpDelivery.adapter';
import { PdpStoreAdapter } from '../infra/adapters/pdpStore.adapter';
import { WishlistAdapter } from '@/features/wishlist/infra/adapters/wishlist.adapter';
import { VideoCallAdapter } from '@/features/video-call/infra/adapters/videoCall.adapter';
import { createProductDetailService } from '../application/services/ProductDetailService';

export function pdpBuild(dispatch: AppDispatch) {
  const detailRepo = new PdpAdapter(dispatch);
  const customizationRepo = new CustomizationAdapter(dispatch);
  const deliveryRepo = new PdpDeliveryAdapter(dispatch);
  const storeRepo = new PdpStoreAdapter(dispatch);
  const wishlistRepo = new WishlistAdapter(dispatch);
  const videoCallRepo = new VideoCallAdapter(dispatch);
  const service = createProductDetailService(
    detailRepo,
    customizationRepo,
    deliveryRepo,
    storeRepo,
    wishlistRepo,
    videoCallRepo
  );
  return { service };
}
